import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./OutOfHomeServiceLinks.css";

// Internal links to the 3 keyword-focused service pages
// (/affichage-numerique, /publicite-interieure, /compagnie-media),
// which otherwise have no path linking to them from anywhere on the
// site. Reuses the shared "oohs-" design system (see
// OutOfHomeSections.css) so it sits visually between "Comment ça
// fonctionne" and the FAQ without introducing a new style language.
const SERVICE_LINKS = [
  { key: "affichageNumerique", path: "/affichage-numerique" },
  { key: "publiciteInterieure", path: "/publicite-interieure" },
  { key: "compagnieMedia", path: "/compagnie-media" },
];

const OutOfHomeServiceLinks = () => {
  const { t } = useTranslation();

  return (
    <div className="oohs-section">
      <div className="oohs-section-inner">
        <h2 className="oohs-title">{t("outOfHomePage.serviceLinks.title")}</h2>

        <div className="ooh-service-links-grid">
          {SERVICE_LINKS.map(({ key, path }) => (
            <Link key={key} to={path} className="oohs-card ooh-service-link-card">
              <h3 className="ooh-service-link-label">
                {t(`outOfHomePage.serviceLinks.${key}.label`)}
              </h3>
              <p className="ooh-service-link-text">
                {t(`outOfHomePage.serviceLinks.${key}.text`)}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OutOfHomeServiceLinks;
